import { getCommercial, postCommercial } from "../.";
import {
  BasicAccountApplicationDashboardDto,
  DashboardDocument,
} from "../generated-types";

const query = (): Promise<DashboardDocument> => {
  return getCommercial("/protected/application/dashboard");
};

const createBasicAccountApplication = async (
  request: BasicAccountApplicationDashboardDto,
): Promise<string> => {
  return postCommercial(
    "/protected/application/dashboard/basic-account",
    request,
  );
};

const DashboardAPI = {
  query,
  createBasicAccountApplication,
};

export default DashboardAPI;
